import type { Messages } from '../messages.js'

/** Dutch. `zetten` for flips: a move you pay for, which is what the meter counts. */
export const nl: Messages = {
  tag: 'nl',

  readingDictionary: 'Woordenboek wordt gelezen…',
  noWordList: 'Geen woordenlijst voor "{language}". Genereer er een:  pnpm dictionary build',
  emptyWordList: 'De woordenlijst voor "{language}" is leeg.',

  flips: 'zetten',
  score: 'punten',
  words: 'woorden',
  round: 'ronde',
  ticksLeftLabel: 'Resterende tijd in deze ronde',
  typeAWord: 'typ een woord',
  tapPrompt: 'tik om te nemen of terug te geven, dan {action}',

  boardOfTiles: 'Bord van {n} stenen',
  faceDown: 'omgedraaid',
  wildCard: 'joker',
  wildKey: 'een willekeurige letter',
  letterReplaced: '{from} werd {to}',
  letterSwap: 'LETTERWISSEL!',
  spentTile: 'gebruikte steen',
  hiddenWhilePaused: 'verborgen tijdens pauze',
  letterInWord: '{letter}, letter {position} van het woord',

  completeWord: 'Woord inleveren',
  completeShort: 'Inleveren',
  reset: 'Wissen',
  pause: 'Pauze',
  resume: 'Doorgaan',
  newGame: 'Nieuw spel',
  paused: 'Gepauzeerd',
  outOfFlips: 'Geen zetten meer',
  finalResult: '{score} punten met {words} in {rounds}',
  playAgain: 'Opnieuw spelen',
  share: 'Delen',
  shareCopied: 'Gekopieerd.',
  shareSelect: 'Kopieer dit:',

  lettersSelect: 'letters selecteren',
  keysWild: 'wordt genomen als je een letter typt die geen enkele steen toont',
  clearsEvery: 'wist alle geselecteerde {letter}',
  undoLastLetter: 'laatste letter terug',
  noWordsYet: 'Nog geen woorden.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'al gevonden',
  reasonTooShort: 'te kort',
  reasonNotAWord: 'geen woord',
  reasonAllFound: 'die heb je allemaal al',
  noSuchLetterUp: 'geen {letter} open',
  nothingUp: 'niets open',
  letterHidden: 'een letter verstopte zich',
  shuffled: 'geschud',
  shuffledAndBilled: 'geschud, {flips} ongebruikte zetten in rekening gebracht',
  tooFewLetters: 'Te weinig letters over',

  gameLanguage: 'taal',
  interfaceLanguage: 'interface',
  dictionarySize: '{common} gewone van {full} woorden',
  filterLanguages: 'Talen zoeken',
  noMatches: 'Geen resultaten',

  nerdMode: 'expertmodus',
  rules: 'Regels',
  difficulty: 'moeilijkheid',
  difficultyNames: { easy: 'makkelijk', medium: 'gemiddeld', hard: 'moeilijk', insane: 'moordend' },
  pausedNoBoard: 'Dit spel komt niet op de ranglijst.',
  about: 'Over',
  themeLabel: 'thema',
  themeNames: { traditional: 'traditioneel', light: 'licht', contrast: 'hoog contrast' },
  tiles: 'stenen (N)',
  secondsPerTick: 'seconden / tik',
  holdTicks: 'wachttikken',
  minWord: 'kortste woord',
  startingFlips: 'zetten bij start',
  wildChance: 'jokerkans',
  replaceChance: 'kans op letterwissel',
  hideChance: 'kans op letterverstopping',
  wordCompleteMode: 'woord af',
  wordCompleteNames: { shuffle: 'schudden', spend: 'opgebruiken', keep: 'houden' },
  flipEconomy: 'zettenhuishouding',
  flipEconomyNames: {
    none: 'geen',
    perLetter: 'per letter',
    fibonacci: 'fibonacci',
    overMinimum: 'boven minimum',
  },
  repeatedLetterKey: 'toets bij dubbele letter',
  keySchemeNames: { cycle: 'doorlopen', advance: 'opschuiven' },
  keySchemeHelp: {
    cycle:
      'A pakt de volgende vrije A, en zodra ze alle in het woord staan, wist het ze. ' +
      'Shift+A wist ze ook.',
    advance: 'A pakt de volgende vrije A. Shift+A wist elke A uit het woord.',
  },

  whatThatMeans: 'Wat dat betekent',
  factRound: 'een ronde',
  factWholeBoardUp: 'hele bord open',
  factRoundCosts: 'een ronde kost',
  factFlipsBuy: 'startzetten leveren',
  factThisBoard: 'dit bord',
  factBoardHadToAdmit: 'bord moest toelaten',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, langste {longest}',
  wordsIncludingOneOf: '{words} waarvan één van {ceiling}',
  scorelessRounds: '{rounds} zonder punten',

  whatAWordPays: 'Wat een woord oplevert',
  columnLetters: 'letters',
  columnCost: 'kosten',
  columnPoints: 'punten',
  columnFlips: 'zetten',
  columnNet: 'netto',

  canonicalRules: 'Officiële regels voor {difficulty}.',
  customRules: 'Afgeweken van de voorinstelling. Scores met eigen regels tellen niet mee.',
  applyAndStart: 'Toepassen en nieuw spel starten',
  changesNextGame: 'Wijzigingen gelden vanaf het volgende spel.',
  presets: 'Voorinstellingen:',

  start: 'Starten',
  restart: 'Opnieuw',
  quit: 'Stoppen',
  quitTitle: 'Dit spel stoppen?',
  restartTitle: 'Dit spel opnieuw starten?',
  restartConfirm: 'Opnieuw',
  quitConfirm: 'Stoppen',
  keepPlaying: 'Doorspelen',
  personalBest: 'Je beste spellen',
  newPersonalBest: 'Nieuw persoonlijk record.',
  columnRank: '#',
  notRanked: 'Eigen regels, dus dit spel telt niet mee.',
  notRankedPaused: 'De klok stopte, dus dit spel telt niet mee.',
  rankOfTotal: '{rank} van {total}',

  howToPlay: 'Hoe je speelt',

  backToGame: 'Terug naar het spel',
  welcomeTitle: 'Welkom bij Blinkered',
  tutorialSkip: 'Overslaan',
  tutorialNext: 'Volgende',
  tutorialBack: 'Terug',
  tutorialStart: 'Beginnen met spelen',
  tutorialHideAgain: 'Dit niet meer tonen',
  tutorialProgress: '{n} van {total}',
  tutorialSkipTitle: 'Rondleiding overslaan?',
  tutGoalTitle: 'Blinkered is een race',
  tutGoalBody:
    'Je begint het spel met een vast aantal zetten, en elke steen die draait kost een zet. Zijn de zetten op, dan is het spel voorbij. Woorden leveren zetten op, en hoe langer het woord, hoe meer zetten je krijgt.',
  tutSpentBody:
    'Letters die je in een woord gebruikt, liggen tot de volgende ronde omgekeerd. Alleen een letterwissel verandert welke letters er op het bord liggen.',
  tutChangeTitle: 'Letters kunnen veranderen',
  tutSameLetters:
    'Een woord gezien dat je niet meer kon spelen? Dezelfde letters komen de volgende ronde terug, geschud op nieuwe plekken.',
  tutPickLetters: 'Tik de letters die je wilt op volgorde aan om een woord te vormen.',
  tutMoreTurn:
    'Er blijven tegels omdraaien terwijl je nadenkt, dus er kan nog een betere letter komen.',
  tutTapBack:
    'Per ongeluk een aangetikt? Tik hem nog eens aan om hem terug te geven. Elke letter, niet alleen de laatste.',
  tutComplete: 'Druk op Klaar als het woord af is.',
  htBoardTitle: 'Het bord',
  htBoardBody:
    'De stenen draaien één voor één om, in willekeurige volgorde. Met de open stenen vorm je woorden.',
  htWordsTitle: 'De woorden',
  htWordsBody:
    'Vorm een woord uit de open stenen door de letters op volgorde te typen of aan te klikken.',
  htFlipsTitle: 'De zetten',
  htFlipsBody:
    'Elke steen die draait kost een zet. Een afgemaakt woord schrijft zetten bij je totaal, en lange woorden geven meer. Zijn de zetten op, dan is het spel voorbij.',
  htRoundTitle: 'De ronde',
  htRoundBody:
    'Draait de laatste steen van een ronde, dan ligt het hele bord even open. Daarna worden de stenen omgedraaid en geschud, en begint een nieuwe ronde.',
  htLanguagesTitle: 'De talen',
  htLanguagesBody:
    '{n}. Elk bord is op te lossen met alledaagse woorden. Een ongewoon woord telt ook mee, als het woordenboek het kent.',
  htKeysTitle: 'Het toetsenbord',
  htWildTitle: 'Jokers',
  htWildBody:
    'Soms verschijnt er een joker in plaats van een letter. Een joker geldt als elke letter die een geldig woord maakt. Een woord dat je al af hebt telt niet.',
  htHideTitle: 'Letters die zich verstoppen',
  htHideBody:
    'Op de moeilijkere niveaus kan een open letter zichzelf weer omdraaien en later in de ronde terugkomen. De tijdbalk krijgt daarvoor een extra streepje, in rood. Al genomen letters draaien zich niet om.',
  tutHideBody:
    'Op de moeilijkere niveaus kan een open letter zichzelf weer omdraaien en later in de ronde terugkomen. Al genomen letters draaien zich niet om.',
  htSwapTitle: 'Wisselende letters',
  htSwapBody:
    'Soms wordt tussen de rondes één letter door een andere vervangen. Je ziet welke letter weg is en welke erbij is gekomen.',
  htLevelsTitle: 'De niveaus',
  htLevelEasy:
    'Dezelfde twaalf letters de hele partij, dus je kunt ze leren en een lijstje met woorden in je hoofd houden. Stenen draaien langzaam en het volle bord blijft lang genoeg staan om je letters rustig te kiezen.',
  htLevelMedium:
    'Af en toe verandert er een letter, waardoor het lastiger wordt om woorden te onthouden die je later wilde spelen. Minder tijd om te kijken en minder om na te denken.',
  htLevelHard:
    'Woorden van drie letters tellen niet meer en ongeveer om de ronde verandert er een letter. Het bord staat er amper of het schudt alweer.',
  htLevelInsane:
    'Alles tegelijk, op volle snelheid. Het bord wordt bijna meteen na de laatste zet geschud.',
  htTouchTitle: 'Het aanraakscherm',
  htTouchBody:
    'Tik op een omgedraaide steen om zijn letter te nemen. Tik op een genomen letter om hem terug te geven. Inleveren en Wissen staan onder het bord.',

  accountTitle: 'Je account',
  menuProfile: 'Mijn profiel',
  menuGames: 'Mijn spellen',
  menuPublicPage: 'Mijn openbare pagina',
  menuSignedInAs: 'Ingelogd als',
  signIn: 'Inloggen',
  signOut: 'Uitloggen',
  signInTitle: 'Inloggen of registreren',
  signInLead: 'Een account bewaart je spellen, op elk apparaat.',
  signInKeepGame: 'Log in om dit spel te bewaren, en elk volgend spel.',
  continueWithApple: 'Doorgaan met Apple',
  continueWithGoogle: 'Doorgaan met Google',
  signInOr: 'of',
  emailLabel: 'E-mail',
  codeLabel: 'Code',
  emailMeACode: 'Stuur me een code',
  working: 'Even geduld…',
  sendNewCode: 'Nieuwe code sturen',
  codeSent: 'Kijk in je mail. De code is 10 minuten geldig.',
  notNow: 'Niet nu',
  badEmail: 'Dat ziet er niet uit als een e-mailadres.',
  badCode: 'Die code werkte niet. Codes verlopen na 10 minuten en gelden één keer.',
  serverBusy: 'Server niet bereikbaar. Probeer het zo nog eens.',
  serverDown: 'Server niet bereikbaar.',
  offline: 'Offline',
  leaderboardTitle: 'Ranglijst',
  leaderboardEmpty: 'Nog geen spellen op deze ranglijst. Wees de eerste.',
  leaderboardWouldBe: 'Waar dit spel zou staan',
  leaderboardThisGame: 'Dit spel',
  leaderboardRanksHere: 'Waar dit spel staat',
  leaderboardOutside: 'Buiten de top vijf.',
  tutAccountTitle: 'Bewaar je scores',
  tutAccountBody:
    'Een account bewaart je spellen, zet je scores op de ranglijst en houdt je profiel bij.',
  ssoCancelled: 'Inloggen geannuleerd.',
  ssoExpired: 'Dat duurde te lang. Log opnieuw in.',
  ssoNoUsername: 'Het account kon niet worden afgemaakt. Probeer het zo nog eens.',
  ssoFailed: 'Dat werkte niet. Probeer het opnieuw, of gebruik je e-mail.',
  tabProfile: 'Profiel',
  countryAny: 'Zeg ik liever niet',
  findCountry: 'Landen zoeken',
  usernameLabel: 'Gebruikersnaam',
  bioLabel: 'Bio',
  countryLabel: 'Land',
  bioHint: 'Geen links. {left}/{max}',
  save: 'Opslaan',
  saving: 'Opslaan…',
  saved: 'Opgeslagen.',
  nameTaken: 'Die naam heeft al iemand.',
  nameTooShort: 'Iets langer, graag.',
  nameTooLong: 'Dat is te lang.',
  nameBadCharacters: 'Alleen letters, cijfers, koppeltekens en liggende streepjes.',
  nameBadEdges: 'Hij moet met een letter of cijfer beginnen en eindigen.',
  nameMixedScripts: 'Kies één alfabet en blijf daarbij.',
  nameReserved: 'Dat lijkt op een naam die wij zelf uitgeven. Kies een andere.',
  nameUnusable: 'Die naam kan niet.',
  bioTooLong: 'Een bio is hoogstens {max} tekens.',
  bioHasLink: 'Links mogen niet in een bio.',
  bioHasControl: 'Daar zitten tekens in die een bio niet kan bevatten.',
  bioUnusable: 'Die bio kan niet.',
  gamesHeading: 'Spellen',
  gamesEmpty: 'Hier staat nog niets. Spellen die je ingelogd speelt, komen hier.',
  gamesEmptyShort: 'Hier staat nog niets.',
  gamesLoading: 'Je spellen worden gelezen…',
  theirGamesLoading: 'Hun spellen worden gelezen…',
  profileLoading: 'Profiel wordt gelezen…',
  playerNotFound: 'Hier is niemand met die naam.',
  columnWhen: 'Wanneer',
  columnRounds: 'rondes',
  columnGame: 'Spel',
  gameLoading: 'Spel wordt gelezen…',
  gameUnreadable: 'Dit spel kon niet worden gelezen.',
  gameNotRanked: 'Gespeeld met aangepaste regels, dus dit spel telt niet mee.',
  detailNotKept: 'De woorden en borden van dit spel worden niet meer bewaard.',
  openingBoard: 'Het beginbord',
  roundByRound: 'Ronde voor ronde',
  roundNothing: 'niets gevonden',
  changeReplaced: '{letter} vervangen op plek {slot}',
  changeWildOn: '{letter} joker op plek {slot}',
  changeWildOff: '{letter} joker weg van plek {slot}',
  keepThisGame: 'Dit spel bewaren',
  savedToYourGames: 'Bewaard bij je spellen.',

  reportThis: 'Rapporteren',
  reportHeading: 'Dit rapporteren',
  reportTheName: 'De naam',
  reportTheBio: 'De beschrijving',
  reportTheScore: 'De score',
  reportWhy: 'Wat is er mis mee? Optioneel.',
  reportSend: 'Rapport versturen',
  reportSent: 'Bedankt. Iemand kijkt ernaar.',
  reportSignIn: 'Meld je aan om iets te rapporteren.',
  reportGone: 'Dat is er niet meer.',
  reportCancel: 'Annuleren',

  deleteAccount: 'Mijn account verwijderen',
  deleteAccountWhat:
    'Dit verwijdert je profiel en elk bewaard spel, voorgoed. Het kan niet ongedaan worden gemaakt.',
  deleteAccountAsk: 'Stuur me een code',
  deleteConfirm: 'Voorgoed verwijderen',
  deleteGone: 'Je account is weg. Bedankt voor het spelen.',
  deleteNoAddress:
    'Er staat geen bevestigd adres op dit account, dus een verwijdering kan niet worden gecontroleerd. Neem contact op en we doen het met de hand.',

  rulesetFacts: 'Woorden van {letters} · elke {seconds} een nieuwe steen',
  plurals: {
    words: { one: '{n} woord', other: '{n} woorden' },
    rounds: { one: '{n} ronde', other: '{n} rondes' },
    flips: { one: '{n} zet', other: '{n} zetten' },
    ticks: { one: '{n} tik', other: '{n} tikken' },
    points: { one: '{n} punt', other: '{n} punten' },
    minLetters: { one: '{n} letter of meer', other: '{n} letters of meer' },
    seconds: { one: '{n} seconde', other: '{n} seconden' },
  },
}
